// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/recurring-journal-entry-batches',
        component: () =>
            import('@/pages/[organisation]/accounting/recurring-journal-entry-batches.vue'),
        name: 'accounting.recurring-journal-entry-batches.search-recurring-journal-entry-batches',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.general-ledger.view-recurring-journal-entry-batches',
        },

        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/recurring-journal-entry-batches/[id].vue'),
                name: 'accounting.recurring-journal-entry-batches.view-recurring-journal-entry-batch',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.general-ledger.view-recurring-journal-entry-batches',
                },
            },
        ],
    },
];
